import { lazy, Suspense, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Text } from '@artprov/design-system'
import PropTypes from 'prop-types'
import MicrofrontendBoundary from '@/common/components/microfrontends/MicrofrontendBoundary.jsx'
import { microfrontends } from '@/common/config/microfrontends.config.js'
import { isInternalMenuUrl } from '@/common/utils/navigation/menu-url.js'
import { resolveNominaUrl } from '@/common/utils/navigation/nomina-url.js'
import { useAuthStore } from '@/common/zustand/store/auth.store.js'

const remoteApps = Object.fromEntries(Object.entries(microfrontends).map(([key, config]) => [key, lazy(config.load)]))

export default function MicrofrontendRemotePage({ microfrontend }) {
  const navigate = useNavigate()
  const sessionUuid = useAuthStore((state) => state.userToken)
  const logout = useAuthStore((state) => state.logout)
  const config = microfrontends[microfrontend]
  const RemoteApp = remoteApps[microfrontend]

  // El remote de Credenciales no resuelve el destino de "Ver nómina": lo navega el host.
  // Nómina puede apuntar al PHP legacy por ambiente (VITE_LEGACY_NOMINA_URL).
  const handleNavigateToNomina = useCallback(() => {
    const target = resolveNominaUrl(microfrontends.nomina.basePath)

    if (isInternalMenuUrl(target)) {
      navigate(target)
      return
    }

    window.location.href = target
  }, [navigate])

  if (!sessionUuid) {
    return <Text variant="body1">Cargando sesión...</Text>
  }

  return (
    <MicrofrontendBoundary name={config.label} onRetry={() => window.location.reload()}>
      <Suspense fallback={<Text variant="body1">Cargando {config.label}...</Text>}>
        <RemoteApp
          key={sessionUuid}
          sessionUuid={sessionUuid}
          initialPath={config.defaultPath}
          onSessionExpired={logout}
          onNavigateToNomina={microfrontend === 'credenciales' ? handleNavigateToNomina : undefined}
        />
      </Suspense>
    </MicrofrontendBoundary>
  )
}

MicrofrontendRemotePage.propTypes = {
  microfrontend: PropTypes.oneOf(Object.keys(microfrontends)).isRequired,
}
